import { Injectable } from '@angular/core';
import { SelectServiceLib } from '../../../core/libraries/Dynamic-fields/components/select/classes/SelectServiceLib.service';

@Injectable()
export class SelectService extends SelectServiceLib {
    /**
     * Получить текущее имя
     */
    public getCurrentName(): string | null {
        const value = this.group?.get(this.field.name).value;
        const options = this.field.options;
        if (!value) {
            return null;
        }

        return options.find((item) => +item.id === +value)?.name ?? null;
    }
}
